<template>
  <div class="shippingDetails subOrderList">
    <header class="fixed_Back_header flx">
      <div class="menu flx">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#FFF" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h3 style="text-transform:capitalize" v-if="orderDetails.subOrderDTOList && orderDetails.subOrderDTOList.length">{{ orderDetails.subOrderDTOList[0].sellerLiteDTO.storeName }}</h3>
      </div>
    </header>
    <section class="main_content" :class="{'paddingMore':$route.query.CLOUDSHOP}">
      <div class="my-sub-order">
        <div class="order-card" v-if="orderDetails.orderId">
          <div class="product-details">           
            <label class="product-details" style="padding-left: 0">
              <!-- <span class="product-img" style="width: 50px; height: 50px">
              <img src="../../assets/images/qrDummy.jpg" alt="product-image" />
            </span> -->
              <div
                class="product-info"
                style="padding-left: 0; padding-bottom: 8px"
              >
                <div class="order-id">
                  <span class="ord-id"
                    >Order ID:
                    <strong>#{{ orderDetails.orderId }}</strong></span
                  >
                </div>
                <p class="date" style="padding-top: 8px">
                  Order Date - <strong>{{ orderDetails.orderDate.slice(0, orderDetails.orderDate.indexOf(',')) }}</strong>
                </p>
              </div>
            </label>
          </div>
          <div class="quantity-detail">
            <p>
              Total item: <span> {{ totalQuantity}} </span>
            </p>
            <p>
              Total price: <span> Rs.{{Math.round(parseFloat(orderDetails.totalPaidAmount) + parseFloat(orderDetails.totalDiscountedAmount)) }} </span>
            </p>
            
          </div>
        </div>
        <div class="order-card" v-if="parseFloat(orderDetails.totalDeliveryCost)>0">
          <div class="product-details">
            <label class="product-details" style="padding-left: 0">
              <div
                class="product-info"
                style="padding-left: 0; padding-bottom: 8px"
              >
                <div class="order-id">
                  <span class="ord-id"
                    >Delivery Charge:
                    <strong style="color:green">Rs. {{ orderDetails.totalDeliveryCost }}</strong></span
                  >
                </div>
                <p class="date" style="padding-top: 8px">
                  Delivery address - <strong>{{ orderDetails.addressDTO.address }}, {{ orderDetails.addressDTO.city }}</strong>
                </p>
                <p class="date" style="padding-top: 8px">
                  Contact Number - <strong>{{ orderDetails.addressDTO.contactNumber }}</strong>
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
      <h4 style="font-size: 0.875em; margin-bottom: 8px; color: #727272" v-if="orders.length > 0">
        List of Items
      </h4>
      <div class="my-sub-order" style="">
        <ul v-if="orders.length > 0">
          <li v-for="(order, index) in orders" :key="index">
            <div class="order-card">
              <div class="product-details">
                 
                <label class="product-details" :class="{'paddingLeft' : !['CONFIRMED','ORDER_DISPATCHED','ORDER_PLACED_TO_SUPPLIER'].includes(order.suborderState)}">
                  <input
                    type="checkbox"
                    :value="order.subOrderId"
                    v-model="checkedOrderIds"
                    v-if="['CONFIRMED','ORDER_DISPATCHED','ORDER_PLACED_TO_SUPPLIER'].includes(order.suborderState)"
                  />
                  <span class="checkmark" v-if="['CONFIRMED','ORDER_DISPATCHED','ORDER_PLACED_TO_SUPPLIER'].includes(order.suborderState)" />

                  <span class="product-img">
                    <img :src="order.itemImage" alt="product-image" />
                  </span>
                  <div class="product-info">
                    <div class="product-title">
                      <h4>{{ order.itemName }}</h4>
                    </div>
                    <div class="color-size">
                      <div v-if="order.itemAttributeDTOs" v-for="itemAttribute in order.itemAttributeDTOs">
                      
                        <span class="product-color" v-if="itemAttribute.itemAttributeName === 'Color'.toUpperCase() || itemAttribute.itemAttributeName === 'Color'.toLowerCase() || itemAttribute.itemAttributeName === 'Color'">
                          {{$t('color')}} :&nbsp;
                          <span class="colour">
                            <span style="text-transform:capitalize;font-weight: 500;">{{itemAttribute.itemAttributeValue }}</span>
                          </span>
                        </span>
                        
                        <span class="product-sz" v-if="itemAttribute.itemAttributeName === 'Size'.toUpperCase() || itemAttribute.itemAttributeName === 'Size'.toLowerCase() || itemAttribute.itemAttributeName === 'Size'">
                          {{$t('size')}} :&nbsp;
                          <span class="size">{{itemAttribute.itemAttributeValue }}</span>
                        </span>
                      </div>
                      </div>
                    <div class="product-price">
                      <div>
                      <span class="selling-price"
                        >Rs.{{ order.totalPaidAmount }}</span
                      ><strike class="mrp" v-if="Math.round(parseFloat(order.sellingPrice) *  parseFloat(order.orderedQuantity)) !== parseFloat(order.totalPaidAmount )">Rs.{{ Math.round(parseFloat(order.sellingPrice) *  parseFloat(order.orderedQuantity)) }}</strike>
                      </div>
                      <p v-if="parseFloat(order.gmallItemId)>0 && order.gmallLocalSupply && !['CANCELLED_BY_SELLER','CANCELLED_BY_USER'].includes(order.suborderState)" class="supply-type local">Local Supply</p>
                  <p v-else-if="parseFloat(order.gmallItemId)>0 && !order.gmallLocalSupply && !['CANCELLED_BY_SELLER','CANCELLED_BY_USER'].includes(order.suborderState)" class="supply-type godaam">Godaam Supply</p>
                    </div>
                    <p class="date" style="padding-top: 8px">
                      Quantity : {{ order.orderedQuantity }}
                    </p>
                     <p class="delivery-info" style="padding-top: 8px">
                    <span>
                    {{ $t("currentState") }}:
                    <b
                      :class="{
                        cancel: [
                          'CANCELLED_BY_SELLER',
                          'CANCELLED_BY_USER',
                          'GROUP_PURCHASE_ORDER_CANCELLED',
                          'GROUP_PURCHASE_ORDER_CANCELLED',
                        ].includes(order.suborderState),
                        dispatched: ['ORDER_DISPATCHED'].includes(
                          order.suborderState
                        ),
                        delivered: ['ORDER_DELIVERED'].includes(
                          order.suborderState
                        ),
                      }"
                    >
                      {{ getText(order.suborderState) }}
                    </b>
                  </span>
                    </p>
                     <p class="delivery-info" v-if="order.suborderStateTransitionDTOs" v-for="orderDate in order.suborderStateTransitionDTOs" style="padding-top:0">
                    <span v-if="orderDate.orderState==='ORDER_DELIVERED'" style="padding-top: 8px" >
                    {{ $t("deliveryDate") }}:
                    <b>
                      {{ orderDate.orderDate }}
                    </b>
                  </span>
                  <span v-else>
                    
                  </span>
                    </p>
                    <p v-if="order.gmallLocalSupply" class="update-price-btn" @click="openUpdateItemPrice(index)">Update Product Price</p>
                    <div class="customModal" v-if="isUpdateItemPriceBox === index">
                      <div class="modal_dialog Cod" style="padding:0">
                        <div class="modal_content" style="padding:15px">
                          <div class="modal_body padding0">
                            <label class="margin-price"><span>Update Product price</span>
                            <input type="number" placeholder="Enter Price" v-model="updateItemPricevalue" />
                            </label>
                          </div>
                        </div>
                        <div class="modal_footer cod">
                          <button
                            type="button"
                            class="order_btn cancel"
                            @click="isUpdateItemPriceBox = !isUpdateItemPriceBox"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            class="order_btn order-now"
                            @click="updateItemPrice(order.sellerItemRelationShipId, order.sellerLiteDTO.shopId)"
                          >
                            Update Price
                          </button>
                        </div>
                      </div>
                    </div>
                     <p v-if="['ORDER_DELIVERED'].includes(order.suborderState) && order.courierPartner == null" class="update-price-btn" @click.prevent="openUpdateTrackingInfo(index)">Update Tracking Info</p>
                    <div class="customModal" v-if="isUpdateTrackingInfo === index">
                      <div class="modal_dialog Cod" style="padding:0">
                        <div class="modal_content" style="padding:15px">
                          <div class="modal_body padding0">
                            <label class="margin-price"><span>Update Tracking Info</span>
                            <input type="text" placeholder="Enter Courier Partner Name" v-model="updateCourierPartnerName" />
                            <input type="number" placeholder="Enter Tracking Number" v-model="updateTrackingNumber" />
                            </label>
                          </div>
                        </div>
                        <div class="modal_footer cod">
                          <button
                            type="button"
                            class="order_btn cancel"
                            @click.prevent="isUpdateTrackingInfo = !isUpdateTrackingInfo"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            class="order_btn order-now"
                            @click.prevent="updateTrackingInfo(order.subOrderId)"
                          >
                            Update Tracking
                          </button>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                </label>
                <div v-if="order.courierPartner" style="background: #f1f1f1;padding: 4px;border-radius: 4px;  margin-top: 8px;">
                    <p class="delivery-info" v-if="order.courierPartner"><span>Courier Partner :<b>{{order.courierPartner}}</b></span></p>
                    <p class="delivery-info" v-if="order.trackingNumber"><span>Tracking Number :<b>{{order.trackingNumber}}</b></span></p>
                    </div>
                <p style="color: #f93;font-size: 0.75em;font-weight: 500;padding: 5px;margin-top: 8px;" v-if="order.suborderState != 'CANCELLED_BY_SELLER' && order.sellerLiteDTO.isGlobalShop">"We will shortly inform you, from where you have to collect your item"</p>
              </div>
              <div v-if="orderDetails.orderPaymentStatus === 'VERIFICATION_FAILED'" class="price-detail">
                <p>
                  You will pay:
                  <span> Rs.{{ order.totalPaidAmount }} </span>
                </p>
                <p v-if="parseFloat(order.totalDiscounts) > 0">
                  Discount Applied:
                  <span> Rs.{{ order.totalDiscounts }} </span>
                </p>
                </div>
                <div v-else-if="orderDetails.orderPaymentStatus === 'PAYMENT_SUCCESSFUL'" class="price-detail">
                  <p>
                    You will pay:
                    <span> Rs. 0 </span>
                  </p>
                  <p v-if="parseFloat(order.totalPaidAmount) > 0">
                    Discount Applied:
                    <span> Rs.{{ Math.round(parseFloat(order.totalDiscounts) + parseFloat(order.totalPaidAmount)) }} </span>
                  </p>
                </div>
                <div v-else-if="parseFloat(orderDetails.totalDeliveryCost)>0" class="price-detail" style="align-items:baseline">
                  <p v-if="order.itemId === deliveryChargeIndex" style="width:55%">
                    Customer will pay:
                    <span> Rs. {{Math.round(parseFloat(order.totalPaidAmount) + parseFloat(orderDetails.totalDeliveryCost))}} </span>
                    <br/><span style="font-weight:normal;font-size:0.75em">(Rs. {{parseFloat(orderDetails.totalDeliveryCost)}}.0  delivery charges added)</span>
                  </p>
                  <p v-else style="width:55%">
                    Customer will pay:
                    <span> Rs. {{order.totalPaidAmount}} </span>
                  </p>
                  <p v-if="parseFloat(order.totalPaidAmount) > 0"  style="width:45%">
                    Discount Applied:
                    <span> Rs.{{ order.totalDiscounts }} </span>
                  </p>
                </div>
                <div v-else class="price-detail">
                  <p>
                    Customer will pay:
                    <span> Rs.{{ order.totalPaidAmount }} </span>
                  </p>
                  <p v-if="parseFloat(order.totalDiscounts) > 0">
                    Discount Applied:
                    <span> Rs.{{ order.totalDiscounts }} </span>
                  </p>
                </div>
               
            </div>
          </li>
        </ul>
      </div>
      <div class="delivered-ftr" style="bottom:45px" v-if="$route.query.CLOUDSHOP">
        <button type="button" class="action-btn cancel widthfull" @click="orderMarkAsdelivered('ORDER_PLACED_TO_SUPPLIER')" :disabled="checkedOrderIds.length <= 0"
        :style="
          checkedOrderIds.length <= 0
            ? 'color: #a2a2a2;border: 1px solid #b7b7b6;background: #d4cdc5;'
            : ''
        ">Mark Order Confirmed</button>
      </div>
      <div class="delivered-ftr">
        <button type="button" class="action-btn cancel" @click="orderCancel('CANCELLED_BY_USER')" :disabled="checkedOrderIds.length <= 0"
        :style="
          checkedOrderIds.length <= 0
            ? 'color: #a2a2a2;border: 1px solid #b7b7b6;background: #d4cdc5;'
            : ''
        " :class="{'widthfull': !$route.query.qrCode, 'codDisabled': isCancelDisabled}">Cancel</button>
        <button type="button" class="action-btn" v-if="$route.query.qrCode" @click="isActiveDeliverPopUp = !isActiveDeliverPopUp  && checkedOrderIds.length > 0" :style="
          checkedOrderIds.length <= 0
            ? 'color: #a2a2a2;border: 1px solid #b7b7b6;background: #d4cdc5;'
            : ''
        " :class="{'widthfull': isCancelDisabled}">Delivered</button>
      </div>
    </section>
    <div class="cancel-popup-wrapper" v-if="orderMarkConfirmPopUp">
      <div class="cancel-popup">
          <img src="../../assets/images/icons/confirm-red.svg" alt="loader" />
          <p>धन्यवाद! आपका आर्डर कन्फर्म कर दिया गया है ।</p>
        <span class="closePopUp" @click="goToListing()">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#727272"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>      
    </div>
    <div class="cancel-popup-wrapper" v-if="orderCancelPopup">
      <div class="cancel-popup">
          <img src="../../assets/images/icons/confirm-red.svg" alt="loader" />
          <p>धन्यवाद! आपका ऑर्डर कैंसिल कर दिया गया है</p>
        <span class="closePopUp" @click="goToListing()">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#727272"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>      
    </div>
    <div class="bottomToUp" v-if="isActiveDeliverPopUp"></div>
      <div class="bottomToUp_content item-deliver" :class="{'activeBottomtoUp' : isActiveDeliverPopUp}" v-if="isActiveDeliverPopUp">
        <div class="price-details">
          <h2><span class="material-icons done">done</span> Pay to&nbsp;<span style="text-transform:capitalize;"> {{ orderDetails.sellerFullName }}</span></h2>
          <div class="item-detail">
            <p><span>Total Item</span><span>{{getGrossQuantity()}}</span></p>
            <p><span>Total Price</span><span>₹{{ Math.round(getCustomerGrossAmount() + getMallGrossAmount()) }}.0</span></p>
          </div>
          <div class="custmr-pay-detail">
            <div v-if="orderDetails.orderPaymentStatus === 'PAYMENT_SUCCESSFUL'">
              <p><span>You will Pay</span><strong>₹ 0</strong></p>
              <p v-if="getCustomerGrossAmount() > 0"><span>Discount Applied</span><strong>₹{{ Math.round(getCustomerGrossAmount() + getMallGrossAmount()) }}.0</strong></p>
            </div>
            <div v-else-if="parseFloat(orderDetails.totalDeliveryCost)>0">
              <p><span>You will Pay</span><strong> ₹{{ Math.round(getCustomerGrossAmount() + parseFloat(orderDetails.totalDeliveryCost)) }}.0</strong></p>
              <p v-if="getMallGrossAmount() > 0"><span>Discount Applied</span><strong>₹{{getMallGrossAmount()}}</strong></p>
            </div>
            <div v-else>
              <p><span>You will Pay</span><strong>₹{{ getCustomerGrossAmount() }}</strong></p>
              <p v-if="getMallGrossAmount() > 0"><span>Discount Applied</span><strong>₹{{getMallGrossAmount()}}</strong></p>
            </div>
            <!-- <p><span>Customer wiil Pay</span><strong>₹{{ getCustomerGrossAmount() }}</strong></p>
            <p v-if="getMallGrossAmount() > 0"><span>Discount Applied</span><strong>₹{{getMallGrossAmount()}}</strong></p> -->
          </div>
          <div class="dlvr-wrap">
            <button class="dlvr-button" @click=" orderConfirm('ORDER_DELIVERED')">CONFIRM</button>
          </div>
        </div>
        <span class="closePopUp" @click="isActiveDeliverPopUp =!isActiveDeliverPopUp">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  </div>
</template>
<script>
import "../../assets/css/order-history.scss";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import CustomToaster from "../../components/Common/CustomToaster";
export default {
  name: "SubOrderList",
  components: {
    CustomToaster
  },
  data() {
    return {
      checkedOrderIds: [],
      orders: [],
      orderDetails: {},
      toasterData: {},
      isToasterData: false,
      loading:false,
      orderCancelPopup: false,
      orderMarkConfirmPopUp:false,
      isActiveDeliverPopUp: false,
      checkedSettlementIds: [],
      isUpdateItemPriceBox: false,
      updateItemPricevalue: null,
      isUpdateTrackingInfo: false,
      updateCourierPartnerName: '',
      updateTrackingNumber: null
    };
  },
  computed: {
    deliveryChargeIndex(){
  //return index -> orders array which index
  if(!this.orders.length) return -1;
  let rejectedConditions = [
    'CANCELLED_BY_SELLER',
    'CANCELLED_BY_USER',
    'GROUP_PURCHASE_ORDER_CANCELLED',
    'GROUP_PURCHASE_ORDER_CANCELLED',
  ]
    let index = this.orders.find(order => rejectedConditions.findIndex(condition => condition === order.suborderState) === -1 )
    if(index  === void 0) return undefined;
    return index.itemId;

    },
    selectedOrderCodAmount() {
      return this.orders
        .filter((data) => this.checkedOrderIds.includes(data.subOrderId))
        .reduce((acc, currentVal) => {
          return acc + Number(currentVal.totalPaidAmount);
        }, 0);
    },
    selectedMallPayCodAmount() {
      return this.orders
        .filter((data) => this.checkedOrderIds.includes(data.subOrderId))
        .reduce((acc, currentVal) => {
          return acc + Number(currentVal.totalDiscounts);
        }, 0);
    },
    selectedTotalQuantity() {
      return this.orders
        .filter((data) => this.checkedOrderIds.includes(data.subOrderId))
        .reduce((acc, currentVal) => {
          return acc + Number(currentVal.orderedQuantity);
        }, 0);
    },
    totalQuantity() {
      return this.orders
        .reduce((acc, currentVal) => {
          return acc + Number(currentVal.orderedQuantity);
        }, 0);
    },
    isCancelDisabled(){
      for(let i in this.orders){
          // cartItemDTOs loop n
          let a = this.orders.filter(cartItem=>
            cartItem.suborderState === 'ORDER_DISPATCHED'
          )
          if(a.length) {
            return true;    
          }          
                    
      }
      return false;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openUpdateTrackingInfo(index){
      this.isUpdateTrackingInfo = index
    },
    updateTrackingInfo(subOrderID){
      if(this.updateCourierPartnerName && parseFloat(this.updateTrackingNumber)>0){
         this.loading = true
      const obj = {
        subOrderId : subOrderID,
        trackingNumber: Number(this.updateTrackingNumber),
        courierPartner: this.updateCourierPartnerName
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        'update-tracking-details-by-suborder',
        'post',
        obj
        ).then((data) => {
          this.loading = false
          this.isUpdateTrackingInfo = !this.isUpdateTrackingInfo;
          this.toasterData = {
            msg: 'Tracking Updated Successfully',
            color: "green",
            iconName: "close",
          };
          this.isToasterData = true;
          this.getOrdersById()
        }).catch(err =>{
           if (
          err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
          err.response.data.message ==
            "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
        ) {
          this.loading = false;
          try {
            _JWT.refereshToken = (res) => {
              if (res != "fail") {
                this.$cookie.set("JWT-TOKEN", res);
                this.updateTrackingInfo(subOrderID);
              } else {
                this.loading = false;
              }
            };
            JSBridgePlugin.refreshTokens("_JWT.refereshToken");
          } catch (err) {
            this.loading = false;
            this.$emit('notLoggedInUser')
            console.log(err);
          }
        }else{
           this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
        }
          this.loading = false
          this.isUpdateTrackingInfo = !this.isUpdateTrackingInfo
        })
      }else{
        this.toasterData = {
          msg: 'Please enter detail',
          color: "#e51c24",
          iconName: "close",
        };
        this.isToasterData = true;
      }
    },
    goToListing(){
      this.$router.push('/manage-shops?shopid='+this.orders[0].sellerLiteDTO.shopId)
      this.$store.commit("saveData", {
        orders: [],
        orderIndex: 0,
        type: "myshop_order",
      });
    },
     getText(orderStatus) {
      let obj = constant.GETTEXT;
      return obj[orderStatus];
    },
    getCustomerGrossAmount() {
      if (this.checkedSettlementIds.length) {
        return this.selectedOrderCodAmount - this.getAmountBySettlementId();
      }
      return this.selectedOrderCodAmount;
    },
    getAmountBySettlementId() {
      const finalObj = this.settlement.find((obj) => {
        return obj.itemId.toString().includes(this.checkedSettlementIds[0]);
      });
      return finalObj.totalPaidAmount;
    },
    getMallGrossAmount() {
      if (this.checkedSettlementIds.length) {
        return this.selectedMallPayCodAmount - this.getMallAmountBySettlementId();
      }
      return this.selectedMallPayCodAmount;
    },
    getMallAmountBySettlementId() {
      const finalObj = this.settlement.find((obj) => {
        return obj.itemId.toString().includes(this.checkedSettlementIds[0]);
      });
      return finalObj.totalDiscounts;
    },
    getGrossQuantity() {
      if (this.checkedSettlementIds.length) {
        return this.selectedTotalQuantity - this.getGrossQuantitySettlementId();
      }
      return this.selectedTotalQuantity;
    },
    getGrossQuantitySettlementId() {
      const finalObj = this.settlement.find((obj) => {
        return obj.itemId.toString().includes(this.checkedSettlementIds[0]);
      });
      return finalObj.orderedQuantity;
    },
    openUpdateItemPrice(index){
      this.isUpdateItemPriceBox = index
    },
    updateItemPrice(sirID,shopid){
      if(parseFloat(this.updateItemPricevalue)>0){
         this.loading = true
      const obj = {
        sellerShopId : shopid,
        sellerItemRelationshipId: sirID,
        sellingPrice: Number(this.updateItemPricevalue)
      }
      ApiCaller(
        constant.CATALOGUE_URL,
        'update-gmall-local-supply-pricing',
        'put',
        obj
        ).then((data) => {
          this.loading = false
          this.isUpdateItemPriceBox = !this.isUpdateItemPriceBox;
          this.toasterData = {
            msg: 'Price Updated Successfully',
            color: "green",
            iconName: "close",
          };
          this.isToasterData = true;
        }).catch(err =>{
           if (
          err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
          err.response.data.message ==
            "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
        ) {
          this.loading = false;
          try {
            _JWT.refereshToken = (res) => {
              if (res != "fail") {
                this.$cookie.set("JWT-TOKEN", res);
                this.updateItemPrice(sirID,shopid);
              } else {
                this.loading = false;
              }
            };
            JSBridgePlugin.refreshTokens("_JWT.refereshToken");
          } catch (err) {
            this.loading = false;
            console.log(err);
          }
        }else{
           this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
        }
          this.loading = false
          this.isUpdateItemPriceBox = !this.isUpdateItemPriceBox
        })
      }else{
        this.toasterData = {
          msg: 'Please enter Price',
          color: "#e51c24",
          iconName: "close",
        };
        this.isToasterData = true;
      }
    },
    orderMarkAsdelivered(value){
      this.loading = true
      const obj = {
        subOrderIds: this.checkedOrderIds,
        orderState: value
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "change-sub-order-state-bulk",
        "post",
        obj
      ).then(data =>{
        try {
          JSBridgePlugin.fireEvents("ORDER_MARKED_CONFIRMED");
        } catch (err) {
          console.log(err);
        }
        this.loading = false
        this.orderMarkConfirmPopUp = true
      }).catch(err=>{
        this.loading = false
         if (
          err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
          err.response.data.message ==
            "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
        ) {
          this.loading = false;
          try {
            _JWT.refereshToken = (res) => {
              if (res != "fail") {
                this.$cookie.set("JWT-TOKEN", res);
                this.orderMarkAsdelivered(value);
              } else {
                this.loading = false;
              }
            };
            JSBridgePlugin.refreshTokens("_JWT.refereshToken");
          } catch (err) {
            this.loading = false;
            console.log(err);
          }
        }else{
           this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
        }
        console.log(err)
      })
    },
    orderCancel(value){      
      this.loading = true
      const obj = {
        subOrderIds: this.checkedOrderIds,
        orderState: value
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "change-sub-order-state-bulk",
        "post",
        obj
      ).then(data =>{
        try {
          JSBridgePlugin.fireEvents("ORDER_CANCEL_FROM_LMALL");
        } catch (err) {
          console.log(err);
        }
        this.loading = false
        this.orderCancelPopup = true
      }).catch(err=>{
        this.loading = false
         if (
          err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
          err.response.data.message ==
            "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
        ) {
          this.loading = false;
          try {
            _JWT.refereshToken = (res) => {
              if (res != "fail") {
                this.$cookie.set("JWT-TOKEN", res);
                this.orderCancel(value);
              } else {
                this.loading = false;
              }
            };
            JSBridgePlugin.refreshTokens("_JWT.refereshToken");
          } catch (err) {
            this.loading = false;
            console.log(err);
          }
        }else{
           this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
        }
        console.log(err)
      })
    },
    orderConfirm(value){
      this.loading = true
      const obj = {
        qrCode: this.$route.query.qrCode,
        subOrderIds: this.checkedOrderIds,
        orderState: value
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "change-sub-order-state-bulk",
        "post",
        obj
      ).then(data =>{
        try {
          JSBridgePlugin.fireEvents("ORDER_DELIVER_FROM_LMALL");
        } catch (err) {
          console.log(err);
        }
        this.loading = false
        this.$cookie.set('orderStatus', 'my_payments')
         this.$router.push('/manage-shops?shopid='+this.orders[0].sellerLiteDTO.shopId)
        
      }).catch(err=>{
        this.loading = false
        console.log(err)
        this.isActiveDeliverPopUp = false
        if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              this.loading = false;
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.orderConfirm(value);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
            }

      })
    },
    getOrdersByQrCode() {
      this.loading = true;
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "get-order-by-qrcode/" + this.$route.query.qrCode,
        "get"
      )
        .then((data) => {
          this.orderDetails = data.data;
          
          if (
            this.orderDetails &&
            this.orderDetails.subOrderDTOList &&
            this.orderDetails.subOrderDTOList.length
          ) {
            this.orders = this.orderDetails.subOrderDTOList;            
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          var _this = this;
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              this.loading = false;
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    _this.getOrdersByQrCode();
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
            }
        });
    },
    getOrdersById() {
      this.loading = true;
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "get-order-by-order-id/" + this.$route.query.byOrderId,
        "get"
      )
        .then((data) => {
          this.orderDetails = data.data;
          if (
            this.orderDetails &&
            this.orderDetails.subOrderDTOList &&
            this.orderDetails.subOrderDTOList.length
          ) {
            this.orders = this.orderDetails.subOrderDTOList;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          var _this = this;
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              this.loading = false;
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    _this.getOrdersById();
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
            }
        });
    },
  },
  mounted() {
    if(this.$route.query.qrCode){
      this.getOrdersByQrCode()
    }else{
      this.getOrdersById();
    }
    
  },
};
</script>
<style lang="scss" scoped>
.modal_footer {
  &.cod {
    // padding: 0 15px 15px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #dddddd;
    button {
      width: 50%;
      border-radius: 0 !important;
      padding: 10px !important;
      &.cancel {
        border-bottom-left-radius: 5px !important;
        color: #007aff !important;
        background: none !important;
      }
      &.order-now {
        border-bottom-right-radius: 5px !important;
        background: #007aff !important;
      }
      &.single {
        width: 100% !important;
        color: #007aff !important;
        background: none !important;
      }
    }
  }
}
.shippingDetails .main_content{
  padding-bottom: 110px;
}
.update-price-btn {
    margin-top: 8px;
    border: 1px solid #0091FF;
    color: #0091FF;
    border-radius: 4px;
    padding: 4px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    font-weight: 600;
        font-size: 0.75em;
}
.margin-price{
  text-align: center;
   display: block;
  span{
    font-size:0.75em 
  }
  input{
        border: 1px solid #ccc;
    padding: 4px;
    font-size: 0.938em;
    
    display: block;
    margin: 4px auto;
    border-radius: 4px;
        text-align: center;
    position: inherit !important;
    opacity: 1 !important;

  }
}
.codDisabled{
  display: none;
}
.subOrderList .my-sub-order .order-card .product-details .paddingLeft{
    padding-left: 0;
    
}
.subOrderList .delivered-ftr .action-btn.widthfull{
  width: 100%;
}
.supply-type{
          margin: 4px;
          width:max-content;
          background: red;
          color: #fff;
          padding: 4px 10px;
          font-size: 0.75em;
          border-radius: 4px;
          &.local{
            background: orange;
          }
          &.godaam{
            background: green;
          }
        }
</style>